module.exports = __webpack_public_path__ + "img/Mahathir_eyes.93885d7f.jpg";